import { render, staticRenderFns } from "./fmSelectDadataPassport.vue?vue&type=template&id=20ba929a&scoped=true"
import script from "./fmSelectDadataPassport.vue?vue&type=script&lang=js"
export * from "./fmSelectDadataPassport.vue?vue&type=script&lang=js"
import style0 from "./fmSelectDadataPassport.vue?vue&type=style&index=0&id=20ba929a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba929a",
  null
  
)

export default component.exports